class phoneFormatHelperClass
{
    protected curPos: any = 0;

    getCAXFormat(phone_num: any, format_for_input = false) {
        let phone_str_num = this.getOnlyNumbes(phone_num);
        let intervals = [1, 3, 3, undefined];
        if (! format_for_input) {
            if (phone_str_num.length == 10) intervals = [3, 3, undefined];
            else if (phone_str_num.length != 11) return phone_str_num;
        } else {
            if (String(phone_str_num).substr(0, 1) == '1') {
                var maxlen = 11;
            } else {
                var maxlen = 10;
                intervals = [3, 3, undefined];
            }
            if (phone_str_num.length > maxlen || phone_str_num.length < 2) return phone_str_num;

        }

        var result = '';
        var start_point = 0;
        for (var interval of intervals) {
            var next_interval = phone_str_num.substr(start_point, interval);
            start_point += interval;
            if (next_interval.length < 0.5) break;
            if (result.length > 0.5) {
                if (result.length < this.curPos + 0.5) this.curPos++;
                result += '-';
            }
            result += next_interval;
        }

        return result;
    }

    getOnlyNumbes(phone_num: any) {
        if (! phone_num) {
            this.curPos = 0;
            return '';
        }
        phone_num += '';
        this.curPos = phone_num.substr(0, this.curPos).replace(/[^0-9]/g, '').length;
        return phone_num.replace(/[^0-9]/g, '');
    }

    phoneInputEvent(event: any) {
        var elem = event.target;
        this.curPos = elem.selectionStart;
        var result = this.getOnlyNumbes(elem.value);
        elem.value = this.getCAXFormat(result, true);
        var pos = this.curPos;
        setTimeout(() => {
            elem.selectionStart = pos;
            elem.selectionEnd = pos;
        }, 1);
        return result;
    }
}

export let phoneFormatter = new phoneFormatHelperClass();



// WEBPACK FOOTER //
// ./src/app/helpers/phone-format.ts